import mergeWith from 'lodash-es/mergeWith';

import { APISuccessAction } from 'mk2/helpers/action';
import { Entity } from 'mk2/schemas';

export interface EntitiesByID<T extends Entity = Entity> {
    [id: string]: T;
}

export interface EntitiesState {
    [entity: string]: EntitiesByID<Entity>;
}

// TODO: When and how to clear?
export function entitiesReducer(state: EntitiesState = {}, action: APISuccessAction) {
    let newState = state;

    if (action.response && action.response.entities) {
        newState = mergeWith({}, state, action.response.entities, (objValue, srcValue) => {
            // always replace arrays completely
            if (Array.isArray(objValue)) {
                return srcValue;
            }
        });
    }

    return newState;
}

export const getEntities = (state: EntitiesState, entity: string) => state[entity] ? state[entity] : undefined;
export const getEntity = (state: EntitiesState, entity: string, id: number | string) => state[entity] && state[entity][id] ? state[entity][id] : undefined;
